<template>
  <div id="layout-header">
    <app-menu></app-menu>
    <order-loader></order-loader>
    <vk-icon class="icon-cart" icon="cart" ratio="2" @click="$router.push({path:'/cart'})"></vk-icon>
    <div class="badge" v-if="stock_cart_count">{{ stock_cart_count }}</div>
  </div>
</template>

<script>
  import AppMenu from './header/AppMenu.vue'
  import OrderLoader from './header/OrderLoader.vue'

  export default {
    name: 'app-header',
    components: {
      AppMenu,
      OrderLoader,
    },
    computed: {
      stock_cart_count () {
        return this.$store.state.stock_cart.length;
      }
    }
  }
</script>

<style scoped>
  #layout-header {
    background-color: #151d66;
    color: #fff;
    padding: 4px 10px;
    display: flex;
    justify-content: space-between;
  }
  .icon-cart {}
  .badge {
    background-color: #c00;
    font-size: 10px;
  }
</style>
